import { useState, useEffect } from "react";
import ImageLinks from "./ImageLinks";
import "./Home.css";
import AnnouncementBar from "./AnnouncementBar";

/* ✅ Images from public/images folder */
const slides = [
  {
    img: "/images/clg-bg.png",
    text: "Welcome to Masters Degree & PG College",
    className: "clg-slide"   // 👈 special class
  },
  {
    img: "/images/bg.png",
    text: "Spacious Library Facility",
    className: ""
  },
  {
    img: "/images/bgimage-bg.png",
    text: "Practical Sessions With Guidance",
    className: ""
  },
];

function Home() {
  const [index, setIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);

      setTimeout(() => {
        setIndex(nextIndex);
        setNextIndex((nextIndex + 1) % slides.length);
        setFade(false);
      }, 1000);

    }, 3000);

    return () => clearInterval(interval);
  }, [nextIndex]);

  return (
    <>
      <div className="home-hero">

        {/* Current Slide */}
        <div
          className={`slide current ${slides[index].className}`}
          style={{ backgroundImage: `url(${slides[index].img})` }}
        />

        {/* Next Slide */}
        <div
          className={`slide next ${fade ? "show" : ""} ${slides[nextIndex].className}`}
          style={{ backgroundImage: `url(${slides[nextIndex].img})` }}
        />

        <h1 className="hero-text">{slides[index].text}</h1>

      </div>

      <AnnouncementBar />
      <ImageLinks />
    </>
  );
}

export default Home;